export const cxpSession = state => state.cxpSession;
